module.exports = __webpack_public_path__ + "bo.68b087c07ed5f46254e7.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bo.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bo.svg
// module chunks = styles